module.exports = __webpack_public_path__ + "static/media/pe.7b3a96cc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pe.svg
// module id = 2184
// module chunks = 0